// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__ZSGiv","rotate":"styles_rotate__TOdrX","circle":"styles_circle__LZPku","dash":"styles_dash__yyRrv"};